module.exports = __webpack_public_path__ + "asset/image-download-screenshot-09973e900d44b705.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/download-screenshot.png
// module id = HCns
// module chunks = 1